"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALFactoryGlobal = exports.AugLoopFactory = void 0;
var AugLoopRuntimeManager_1 = require("./AugLoopRuntimeManager");
var runtime_client_1 = require("@augloop/runtime-client");
var AugLoopFactory = /** @class */ (function () {
    function AugLoopFactory() {
        this._augLoopRuntimeManager = new AugLoopRuntimeManager_1.AugLoopRuntimeManager();
    }
    AugLoopFactory.prototype.getAugLoopRuntimeManager = function () {
        return this._augLoopRuntimeManager;
    };
    AugLoopFactory.prototype.createSingleItemWorkflow = function (id) {
        return runtime_client_1.SingleItemWorkflow.create(id);
    };
    return AugLoopFactory;
}());
exports.AugLoopFactory = AugLoopFactory;
/* eslint-disable-next-line @typescript-eslint/naming-convention */
exports.ALFactoryGlobal = new AugLoopFactory();
//# sourceMappingURL=AugLoopFactory.js.map